<template>
  <div  :class="setClass(config)">
    <component ref="form" :is="config.name" :mode="mode" v-bind="config.props" v-model="_value" @change="change" @delInput="delInput" :readerMode="readerMode" :perm="config.perm" :labelTitle="config.title" :userInfo="userInfo" />
  </div>
</template>
<script>

import components from '@/pages/officeApproval/common/form/ComponentExport'
export default {
  name: "FormRender",
  components: components,
  props:{
    mode:{
      type: String,
      default: 'DESIGN'
    },
    readerMode: {
      type: Boolean, 
    },
    value: {
      default: undefined
    },
    config:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
    userInfo:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
  },
  computed: {
    _value: {
      get() {
        const valueType = this.config.valueType
        const value = valueType === "Number" && this.value ? Number(this.value) : this.value;
        return value;
      },
      set(val) {
        // console.log('Render>>',val)
        const valueType = this.config.valueType
        const value = valueType === "Number" ? Number(val) : val
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      hiddenError:false
    }
  },
  methods: {
    setClass(item){
      if(!item.perm || item.name ==='Description') return
      let name = item.perm.toLowerCase()
      if (this.hiddenError) {
          return 'box-'+name+' no-error'
      }else{ 
        return 'box-'+name
      }
      
    },
    validate(call){
      this.$refs.form.validate(call)
    },
    change(e){
      // console.log('change>>',e)
      this._value = e
    },
    delInput(){
      this.$emit("delInput",this.config.id)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
